import '../styles/index.scss';
import mdcAutoInit from '@material/auto-init';
import {MDCRipple} from '@material/ripple';
import {MDCTextField, MDCTextFieldIcon} from '@material/textfield';
import {MDCPersistentDrawer, MDCTemporaryDrawer} from '@material/drawer';
import {MDCTopAppBar} from '@material/top-app-bar';
import {MDCMenu, Corner} from '@material/menu';
import {MDCSelect} from '@material/select';
import {MDCDialog} from '@material/dialog';
import {Collapse} from 'bootstrap/js/src/collapse.js';
import $ from 'jquery/dist/jquery.js';
import * as Cookie from 'js-cookie/src/js.cookie.js';
//import * as Select2 from 'select2/dist/js/select2.min.js';

const MENU_CLOSED_COOKIE = "rq_menu_closed";

mdcAutoInit.register('MDCRipple', MDCRipple);
mdcAutoInit.register('MDCTextField', MDCTextField);
mdcAutoInit.register('MDCTopAppBar', MDCTopAppBar);
mdcAutoInit.register('MDCSelect', MDCSelect);
mdcAutoInit.register('MDCTextFieldIcon', MDCTextFieldIcon);



function initMainMenu(){
  const mainMenu = new MDCPersistentDrawer(document.querySelector('.mdc-drawer--persistent'));
  const mainMenuMobile = new MDCTemporaryDrawer(document.querySelector('.mdc-drawer--temporary'));
  mainMenuMobile.open = false;
  mainMenu.open = Cookie.get(MENU_CLOSED_COOKIE)=='true'?false:true;
  document.querySelector('.rq-main-menu-desktop-toggle').addEventListener('click', () => {
    if(mainMenu.open){
      Cookie.set(MENU_CLOSED_COOKIE, 'true');
    } else {
      Cookie.set(MENU_CLOSED_COOKIE, 'false');
    }
    mainMenu.open = !mainMenu.open;
  });
  document.querySelector('.rq-main-menu-mobile-toggle').addEventListener('click', () => mainMenuMobile.open = true);
}

function initDialogs(){
  const dialogs = $('.rq-auto-init-dialog');
  dialogs.each(function(){
    const dialogElem = $(this);
    const id = dialogElem.attr('id');
    const dialogTriggerElem = $('.rq-auto-init-dialog-trigger[data-trigger-for="#'+ id +'"]');
    const loadURL = dialogTriggerElem.data('load-url');
    const loadParams = dialogTriggerElem.data('load-params');
    const dialog = new MDCDialog(dialogElem[0]);
    dialogTriggerElem.click(function(e){
      if(loadURL){
        $.get(loadURL, loadParams || {}, function(data){
          dialogElem.find('.mdc-dialog__body').html(data);
          dialog.show();
        });
      } else {
        dialog.show();
      }
    });
  });
}

window.openCustomDialog = function(dialogID){
  window.customMDCDialogs = window.customMDCDialogs || [];
  if(window.customMDCDialogs[dialogID]){
    window.customMDCDialogs[dialogID].show();
  } else {
    const dialog = $('#'+dialogID);
    if(dialog.length === 1){
      const dialogElem = dialog[0];
      const dialogObj = new MDCDialog(dialogElem);
      window.customMDCDialogs.push(dialogObj);
      dialogObj.show();
    }
  }
};

function initSubmenus(){
  const menuButtons = document.querySelectorAll('.rq-submenu-trigger');
  menuButtons.forEach(button => {
    const menuSelector = button.getAttribute("data-trigger-for");
    const menuPosition = button.getAttribute("data-trigger-menu-position");
    const menu = new MDCMenu(document.querySelector(menuSelector));
    let position = Corner.BOTTOM_LEFT;
    if(menuPosition){
      switch (menuPosition) {
        case 'bottom-right':
          position = Corner.BOTTOM_RIGHT;
          break;
        case 'bottom-end':
          position = Corner.BOTTOM_END;
          break;
        case 'top-right':
          position = Corner.TOP_RIGHT;
          break;
        case 'bottom-left':
          position = Corner.BOTTOM_LEFT;
          break;
      }
    }
    menu.setAnchorCorner(position);
    button.addEventListener('click', () => menu.open = !menu.open);
  });
}

function initCollapse(){
  $('.collapse').collapse();
  $('.rq-expand-all').each(function(){
    let elem = $(this);
    let targets = $(elem.attr('data-target'));
    elem.click(function(e){
      e.preventDefault();
      if(elem.attr('data-expanded') === 'true'){
        targets.collapse('hide');
        elem.attr('data-expanded','false');
      } else {
        targets.collapse('show');
        elem.attr('data-expanded','true');
      }
    });
  });
  $('.rq-radio-toggler').each(function(){
    if($(this).is(':checked')){
      activateRadioToggled($(this));
    }
    $(this).change(function(){
      activateRadioToggled($(this));
    });
  });
}

function activateRadioToggled(togglerElem){
  let elem = togglerElem;
  let name = elem.attr('name');
  $('input[name="'+ name +'"]').each(function(){
    let el = $(this);
    $(el.attr('data-target')).collapse('hide');
  });
  $(elem.attr('data-target')).collapse('show');
}


	  
//initAutocomplete();
initMainMenu();
initSubmenus();
initCollapse();
initDialogs();
mdcAutoInit();